module.exports = __webpack_public_path__ + "b50e941c713192763a0e0a5dbbcf757f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/neu/risiko-neu.svg
// module id = 133
// module chunks = 1